export default __webpack_public_path__ + "static/media/NowYouTry.fbdfa000.mp3";